<template>
	<BaseCmsPage v-slot="{page}">
        <CmsIntroContainer :page="page">
            <template #h1>
                <h1 v-if="page?.seo_h1">{{ page.seo_h1 }}</h1>
            </template>
        </CmsIntroContainer>      

		<ClientOnly>
			<div class="wider-wrapper">
				<UiLoader color="black" size="large" v-if="loading" />
				<div class="global-error" v-if="error"><BaseCmsLabel :code="error" /></div>
			</div>
		</ClientOnly>
	</BaseCmsPage>
</template>

<script setup>
	const nuxtApp = useNuxtApp();
	const endpoints = useEndpoints();
	const {fetchCart} = useWebshop();
	const {getAppUrl} = useApiRoutes();
	const loading = ref(false);
	const route = nuxtApp._route;
	const error = ref('');

	onMounted(async () => {
		if(route?.query?.cartlink){           
		   	loading.value = true;
		   	const cartLink = route?.query?.cartlink;
		   
			const res = await useApi(
				endpoints.get('_post_hapi_webshop_cart_link'),
				{
					body: {
						code: cartLink,
					},
					method: 'POST',
				},
				
			);

			loading.value = false;

			if(res.success){
				await fetchCart();			
				navigateTo({path: getAppUrl('webshop_shopping_cart')});
				return;
			}

			error.value = res.data.label_name;	
        }		
	});
</script>

<style lang="less" scoped>
	.wider-wrapper{padding-top: 20px;}
	.global-error{max-width: 500px;}
	:deep(.lds-ring){
		div{width: 24px; height: 24px;}
	}
</style>
